/**
 * Detects the _mobile_ platform, iOS or Android. Other platforms and desktop will return undefined.
 * @returns "ios" | "android" | undefined
 */
const getMobilePlatform = (): "ios" | "android" | undefined => {
  let maxTouchPoints = window.navigator.maxTouchPoints;
  let userAgent = window.navigator.userAgent;

  if (/Android/i.test(userAgent)) {
    return "android";
    // maxTouchPoints is the only effective method to detect iPad iOS 13+
    // https://developer.apple.com/forums/thread/119186
  } else if (
    (!(window as any).MSStream &&
      !/X11|Linux|Windows/i.test(userAgent) &&
      maxTouchPoints &&
      maxTouchPoints > 0) ||
    /iPhone|iPad|iPod/i.test(userAgent)
  ) {
    return "ios";
  }
};

export { getMobilePlatform };
